var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return !_vm.item.hidden ? _c("div", {
    staticClass: "menu-wrapper"
  }, [_vm.hasOneShowingChild(_vm.item.children, _vm.item) && (!_vm.onlyOneChild.children || _vm.onlyOneChild.noShowingChildren) && !_vm.item.alwaysShow ? [_vm.onlyOneChild.meta ? _c("app-link", {
    attrs: {
      to: _vm.resolvePath(_vm.onlyOneChild.path),
      url: _vm.item.url,
      item: _vm.item,
      parent: _vm.parent
    }
  }, [_c("div", {
    staticClass: "menu-link",
    class: {
      "is-active": _vm.isLeafActive(_vm.onlyOneChild),
      "menu-link--nest": _vm.isNest,
      "submenu-title-noDropdown": !_vm.isNest
    }
  }, [_c("item", {
    attrs: {
      icon: _vm.onlyOneChild.meta.icon || _vm.item.meta && _vm.item.meta.icon,
      title: _vm.onlyOneChild.meta.title
    }
  })], 1)]) : _vm._e()] : _c("div", {
    staticClass: "sidebar-submenu"
  }, [_c("div", {
    staticClass: "submenu-title",
    class: {
      "is-open": _vm.subExpanded,
      "has-active-child": _vm.hasActiveDescendant
    },
    on: {
      click: _vm.toggleSub
    }
  }, [_vm.item.meta ? _c("item", {
    attrs: {
      icon: _vm.item.meta.icon,
      title: _vm.item.meta.title
    }
  }) : _vm._e(), _c("span", {
    staticClass: "submenu-caret",
    class: {
      "is-open": _vm.subExpanded
    }
  })], 1), _c("div", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.subExpanded,
      expression: "subExpanded"
    }],
    staticClass: "submenu-children"
  }, _vm._l(_vm.item.children, function (child) {
    return _c("sidebar-item", {
      key: child.path || child.name,
      staticClass: "nest-menu",
      attrs: {
        "is-nest": true,
        item: child,
        parent: _vm.item,
        "base-path": _vm.resolvePath(child.path)
      }
    });
  }), 1)])], 2) : _vm._e();
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };